import React, { Component } from 'react';
import $ from "jquery";
import './css/Location.css';
import { IconButton } from '../components/IconButton';
import { cmsAccount, jsonHeaders } from '../components/NavMenu';
import { flushSync } from 'react-dom';
import { WarningBox } from '../components/WarningBox';

export class Location extends Component {
    constructor(props) {
        super(props);
        this.state = {
            account: {},
            location: [],
            showWarningBox: false,
            toDelLocation: {}
        };
    }

    componentDidMount() {
        const intervalId = setInterval(() => {
            if (cmsAccount) {
                flushSync(() => {
                    this.setState({ account: cmsAccount })
                })
                this.fetchLocation();
                clearInterval(intervalId);
            }
        }, 100);
    }

    fetchLocation() {
        const { account } = this.state;
        var requestOptions = {
            method: 'GET',
            headers: jsonHeaders,
            redirect: 'follow'
        };
        fetch(`/api/locations/`, requestOptions)
            .then(response => response.ok ? response.json() : [])
            .then(result => {
                console.log(result)
                this.setState({ location: result });
            })
    }

    addLocation() {
        const { account } = this.state;

        let name = "";
        let address = "";
        while (name == "") {
            name = prompt("Please enter location's name.");
            if (name == null)
                return;
        }
        address = prompt("Please enter address.");
        if (address == null)
            return;


        var requestOptions = {
            method: 'POST',
            headers: jsonHeaders,
            body: JSON.stringify({
                name: name,
                address: address,
                companyUUID: account.companyUUID
            }),
            redirect: 'follow'
        };
        fetch(`/api/locations/`, requestOptions)
            .then(response => response.json())
            .then(result => {
                console.log(result)
                if (!result.id) {
                    alert(result);
                    return;
                }
                this.fetchLocation();
            })
    }

    deleteLocation(uuid) {
        var requestOptions = {
            method: 'DELETE',
            headers: jsonHeaders,
            redirect: 'follow'
        };
        fetch(`/api/locations/${uuid}`, requestOptions)
            .then(response => response.json())
            .then(result => {
                console.log(result)
                this.fetchLocation();
            })
    }

    updateLocation(uuid, property, newValue) {
        const raw = {};
        raw[property] = newValue;

        var requestOptions = {
            method: 'PUT',
            headers: jsonHeaders,
            body: JSON.stringify(raw),
            redirect: 'follow'
        };
        fetch(`/api/locations/${uuid}`, requestOptions)
            .then(response => response.json())
            .then(result => {
                this.fetchLocation();
                if (!result.id) {
                    alert(result);
                    return;
                }
            })
    }

    render() {
        const { account, location, showWarningBox, toDelLocation } = this.state;
        return (
            <>
                <div className='location-page'>
                    <div>
                        <div className='location-table'>
                            <table>
                                <thead>
                                    <tr>
                                        <th>Location</th>
                                        <th>Address</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {location.map((loc) => {
                                        return (
                                            <>
                                                <tr className='header' key={loc.uuid}>
                                                    <td>
                                                        <div className="input-group flex-nowrap">
                                                            {loc.name == "Unassigned" ?
                                                                <input type="text" className="form-control" defaultValue={loc.name} maxLength={64} disabled
                                                                    onBlur={(e) => {
                                                                        this.updateLocation(loc.uuid, "name", e.target.value)
                                                                    }} /> :
                                                                <input type="text" className="form-control" defaultValue={loc.name} maxLength={64}
                                                                    onBlur={(e) => {
                                                                        this.updateLocation(loc.uuid, "name", e.target.value)
                                                                    }} />
                                                            }
                                                        </div>
                                                    </td>
                                                    <td>
                                                        {/* {loc.address} */}
                                                        <div className="input-group flex-nowrap address">
                                                            {loc.name == "Unassigned" ?
                                                                <></> :
                                                                <input type="text" className="form-control" defaultValue={loc.address} maxLength={64}
                                                                    onBlur={(e) => {
                                                                        this.updateLocation(loc.uuid, "address", e.target.value)
                                                                    }} />
                                                            }
                                                        </div>
                                                    </td>
                                                    <td>
                                                        {loc.name == "Unassigned" ?
                                                            <></> :
                                                            <IconButton
                                                                src={"icons/delete.svg"}
                                                                srcWhite={"icons/delete-white.svg"}
                                                                onClick={() => {
                                                                    this.setState({
                                                                        showWarningBox: true,
                                                                        toDelLocation: loc
                                                                    })
                                                                }}
                                                            />
                                                        }

                                                    </td>
                                                </tr>
                                            </>
                                        )
                                    })}
                                </tbody>
                            </table>
                        </div>
                        <div style={{ textAlign: "right", marginRight: "200px" }}>
                            <button onClick={() => { this.addLocation() }}>add location</button>
                        </div>
                    </div>
                </div>
                <WarningBox
                    shown={showWarningBox}
                    message={`Delete ${toDelLocation.name}`}
                    description={"Are you sure to delete this location? This action cannot be undo."}
                    close={(yes) => {
                        if (yes) {
                            this.deleteLocation(toDelLocation.uuid)
                        }
                        this.setState({ showWarningBox: false })
                    }}
                />
            </>
        );
    }
}